import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { currency_converter_inr } from "../../utils/currencyUtils";
import CountUp from "react-countup";
import AddClient from "../client/add_client";
function Client() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const navigate = useNavigate();

  const [clientStatus, SetclientStatus] = useState([]);
  const [bd, Setdb] = useState([]);
  const [industries, Setindustries] = useState([]);
  const [countries, Setcountries] = useState([]);
  const [financialyear, Setfinancialyear] = useState([]);
  const [options, setoptions] = useState([]);
  const [fy, setfy] = useState(null);
  const [ffy, setffy] = useState();
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [total_clients, settotal_clients] = useState(null);
  const [active_clients, setactive_clients] = useState(null);
  const [inactive_clients, setinactive_clients] = useState(null);
  const [new_clients, setnew_clients] = useState(null);
  const [addClientModal, setAddClientModal] = useState(false);

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/clients/get_client_list/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setoptions(response.data.client || []);
        setOptionsLoaded(true);
        console.log(response.data);
        settotal_clients(response.data.total_clients[0].total_clients);
        setactive_clients(response.data.active_clients[0].total_active);
        setinactive_clients(response.data.inactive_clients[0].total_inactive);
        setnew_clients(response.data.new_clients[0].new_client);
      } catch (error) {
        console.error("API Error:", error);
        setoptions([]); // Prevent errors from breaking UI
        setOptionsLoaded(true);
      }
    }
    fetchOptions();

    setfy(fyf());
  }, []);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
    }
  }, [options]);

  const financial_year = async () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth is 0-based

    const endYear = currentMonth < 4 ? currentYear - 1 : currentYear;
    const year = [];
    for (let startYear = 2018; startYear <= endYear; startYear++) {
      year.push(`${startYear}-${startYear + 1}`);
    }

    return year;
  };

  const fyf = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth is 0-based
    const shortYear = currentYear % 100;

    const year =
      currentMonth < 4
        ? `${shortYear - 1}-${shortYear}`
        : `${shortYear}-${shortYear + 1}`;
    return year;
  };

  useEffect(() => {
    async function get_filter_dropdowns() {
      try {
        const [client_status, business_developed, industry, country] =
          await Promise.all([
            axios.get(`${API_BASE_URL}/common_controller/get_client_status`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }),
            axios.get(
              `${API_BASE_URL}/common_controller/get_business_developed/`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
            axios.get(
              `${API_BASE_URL}/common_controller/get_master_industry_list/`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
            axios.get(`${API_BASE_URL}/common_controller/get_countries_list/`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }),
          ]);
        SetclientStatus(client_status.data.options);
        Setdb(business_developed.data.options);
        Setindustries(industry.data.options);
        Setcountries(country.data.options);

        const $country_select = $("select[name='countries']");
        setTimeout(() => {
          $country_select.select2({
            placeholder: "Select Country",
          });
        }, 100);

        $country_select.on("change", function (e) {
          const selectedValues = $(this).val();
          setValue("countries", selectedValues || []);
        });
        return () => {
          $country_select.select2("destroy");
        };
      } catch (error) {
        console.log(error);
      } finally {
      }
    }

    async function init() {
      await get_filter_dropdowns();

      const years = await financial_year(); // <-- FIXED: Await the async call
      Setfinancialyear(years);
    }

    init();
  }, []);

  const filterform = async (data) => {
    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/get_client_filtered_list/`,
        {
          formData: data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setoptions(response.data.client || []);
      setffy(response.data.fy);
      setOptionsLoaded(true);
    } catch (error) {
      console.log(error);
      alert(error.response.data.error);
      window.location.reload();
      setOptionsLoaded(true);
    }
  };

  const handleReset = () => {
    reset();
    window.location.reload();
  };

  const financial_year_change = async (e) => {
    let year = e.target.value;
    if (year != "") {
      $("[name='client_status']").attr("disabled", true);
      $("[name='gka']").attr("disabled", true);
    } else {
      $("[name='client_status']").attr("disabled", false);
      $("[name='gka']").attr("disabled", false);
    }
  };

  const data = [];
  const check_client_status_or_new_old = async (e) => {
    let value = e.target.value;
    if (value != "") {
      data.push(value);
      $("[name='financial_year']").attr("disabled", true);
    } else {
      data.pop(value);
    }
    if (data.length <= 0) {
      $("[name='financial_year']").attr("disabled", false);
    }
  };

  useEffect(() => {
    $('[name="client_search"]').select2({
      multiple: false,
      closeOnSelect: true,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/clients/companyLoad`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          console.log(
            "Sending JSON:",
            JSON.stringify({ keywords: params.term })
          ); // Debugging
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          console.log(data.options);
          if (!data.options || data.options.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.options.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Client",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No client found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='client_search']").on("change", function () {
      const selectedValues = $(this).val() || [];
      navigate(`/client/view/${selectedValues}`);
    });

    return () => {
      $("[name='client_search']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  // const handleExport = (table) => {
  //   const visibleColumns = table.getVisibleLeafColumns();
  //   const visibleRows = table.getRowModel().rows;
  //   exportExcel({ table, columns: visibleColumns, rows: visibleRows });
  // };

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Clients</h2>
          </div>
        </div>
        {addClientModal && (
          <AddClient onClose={() => setAddClientModal(false)} />
        )}
        <div className="row" style={{ marginTop: "-20px" }}>
          <div
            style={{ cursor: "pointer" }}
            onClick={(e) => setAddClientModal(true)}
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-user-plus fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <a
                        href="javascript:void(0);"
                        className="text-secondary fw-semibold me-2 d-inline-block"
                        onClick={(e) => setAddClientModal(true)}
                      >
                        Create New Client
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/contract/list")
            }
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-file-contract fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/contract/list"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Contracts
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/client/clientrisk")
            }
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-fire fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/client/clientrisk"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Client at Risk
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/client/revenuerisk")
            }
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-money-bills fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/client/revenuerisk"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Revenue at Risk
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center">
                        <i className="ti ti-users-group text-pink fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Total Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={total_clients ? total_clients : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-share fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Active Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={active_clients ? active_clients : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-pause fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Inactive Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={inactive_clients ? inactive_clients : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-plus fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        New Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={new_clients ? new_clients : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div
            className="accordion accordion-secondary"
            id="accordionSecondaryExample"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSecondaryOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSecondaryOne"
                  aria-expanded="false"
                  aria-controls="collapseSecondaryOne"
                >
                  Use filters to find specific set of clients:
                </button>
              </h2>
              <div
                id="collapseSecondaryOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingSecondaryOne"
                data-bs-parent="#accordionSecondaryExample"
              >
                <div className="accordion-body">
                  <form onSubmit={handleSubmit(filterform)}>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Client Type:
                            <span className="text-danger">
                              *{" "}
                              {errors.client_type && errors.client_type.message}
                            </span>
                          </label>
                          <select
                            {...register("client_type")}
                            className="form-select"
                          >
                            <option key={0} value={""}>
                              Select Client Type
                            </option>
                            <option key={1} value={2}>
                              Contingent
                            </option>
                            <option key={2} value={3}>
                              Retained
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Client Status:
                            <span className="text-danger">
                              *{" "}
                              {errors.client_status &&
                                errors.client_status.message}
                            </span>
                          </label>
                          <select
                            {...register("client_status")}
                            onChange={check_client_status_or_new_old}
                            className="form-select"
                          >
                            <option value={""}>Select Client Status</option>
                            {clientStatus.length > 0
                              ? clientStatus.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">New/Old:</label>
                          <select
                            {...register("gka")}
                            className="form-select"
                            onChange={check_client_status_or_new_old}
                          >
                            <option key={0} value={""}>
                              Select Option
                            </option>
                            <option key={1} value={"new"}>
                              New
                            </option>
                            <option key={2} value={"old"}>
                              Old
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Business Developed:
                          </label>
                          <select {...register("bd")} className="form-select">
                            <option value={""}>Select BD</option>
                            {bd.length > 0
                              ? bd.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Sector:</label>
                          <select
                            {...register("industry")}
                            className="form-select"
                          >
                            <option value={""}>Select Sector</option>
                            {industries.length > 0
                              ? industries.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Financial Year:</label>
                          <select
                            {...register("financial_year")}
                            className="form-select"
                            onChange={financial_year_change}
                          >
                            <option value={""}>Select Financial Year</option>
                            {financialyear.length > 0
                              ? financialyear.map((item, index) => (
                                  <option key={index} value={item}>
                                    {item}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Country:</label>
                          <select
                            className="form-select"
                            {...register("countries")}
                            multiple
                          >
                            {countries.length > 0
                              ? countries.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <button type="submit" className="btn btn-primary">
                          Search with filter(s)
                        </button>
                      </div>
                      <div
                        className="col-md-3 md-offset-6"
                        style={{ marginLeft: "-65px" }}
                      >
                        <button
                          className="btn btn-secondary"
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center flex-wrap row-gap-3">
            <h5>Quick Search:</h5>
            <div className="col-md-9" style={{ marginLeft: "10px" }}>
              <div className="input-icon-end position-relative remove-icon">
                <select
                  style={{ width: "100%" }}
                  {...register("client_search", {
                    required: false,
                  })}
                  id="select-client"
                ></select>
              </div>
            </div>
            <div className="me-2 ms-5">
              <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                <a
                  onClick={() => navigate("/client/list")}
                  className="btn btn-icon btn-sm me-1"
                >
                  <i className="ti ti-list-tree"></i>
                </a>
                <a
                  onClick={() => navigate("/client/grid")}
                  className="btn btn-icon btn-sm active bg-primary text-white"
                >
                  <i className="ti ti-layout-grid"></i>
                </a>
              </div>
            </div>
          </div>
          <>
            <div className="content">
              <div className="row">
                {options &&
                  options.length > 0 &&
                  options.map((options, index) => (
                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex justify-content-center align-items-center mb-2">
                            <Link
                              to={`/client/view/${options.client_id}`}
                              className={`avatar avatar-xl avatar-rounded ${
                                options.client_status == "Active"
                                  ? `active`
                                  : options.client_status == "Inactive"
                                  ? `inactive`
                                  : `idle`
                              } border rounded-circle`}
                            >
                              <img
                                src={
                                  options.logo
                                    ? `${PINE_BASE_URL}/files/companyLogo/${options.logo}`
                                    : `${PINE_BASE_URL}/files/companyLogo/nologo.png`
                                }
                                className="img-fluid h-auto w-auto"
                                alt="logo"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${PINE_BASE_URL}/files/companyLogo/nologo.png`;
                                }}
                              />
                            </Link>
                          </div>
                          <div className="text-center mb-3">
                            <h6 className="mb-1">
                              <Link
                                to={`/client/view/${options.client_id}`}
                              >
                                {options.company_name}
                              </Link>
                            </h6>
                          </div>
                          <div className="d-flex flex-column">
                            <p className="text-dark d-inline-flex align-items-center mb-2">
                              <i className="ti ti-user text-gray-5 me-2"></i>
                              {options.bd_by} (BD)
                            </p>
                            <p className="text-dark d-inline-flex align-items-center mb-2">
                              <i className="ti ti-user text-gray-5 me-2"></i>
                              {options.client_managed_by} (CM)
                            </p>
                          </div>
                          <div className="d-flex align-items-center justify-content-between border-top pt-2 mt-2">
                            <div className="d-flex align-items-center">
                              <div className="ms-2">
                                <span className="fs-12 fw-normal">Sector</span>
                                <h6 className="fw-normal fs-12">
                                  {options.industryMaster}
                                </h6>
                              </div>
                            </div>
                            <div className="d-flex align-items-end ms-auto text-end">
                              <div>
                                <span className="fs-12 fw-normal">Origin</span>
                                <h6 className="fw-normal fs-12">
                                  {options.country_name}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="d-flex align-items-center">
                              <div className="ms-2">
                                <span className="fs-12 fw-normal">
                                  Revenue 25-26
                                </span>
                                <h6 className="fw-normal fs-12">
                                  {currency_converter_inr(
                                    options.current_revenue ?? 0
                                  )}
                                </h6>
                              </div>
                            </div>
                            <div className="d-flex align-items-end ms-auto text-end">
                              <div>
                                <span className="fs-12 fw-normal">
                                  Life Time Revenue
                                </span>
                                <h6 className="fw-normal fs-12">
                                  {currency_converter_inr(
                                    options.total_revenue ?? 0
                                  )}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
                            <div className="d-flex align-items-center">
                              <span className="avatar avatar-sm avatar-rounded bg-success-transparent flex-shrink-0 me-2">
                                <i className="ti ti-checklist text-success fs-16"></i>
                              </span>
                              <p>
                                <small>Active Roles: </small>
                                <span className="d-inline-flex">
                                  {options.active_roles}
                                </span>
                              </p>
                            </div>
                            <div className="avatar-list-stacked avatar-group-sm align-items-right">
                              <small>Closed : </small>
                              <span className="d-inline-flex">
                                {options.total_closed}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              {/* <div className="text-center mb-4">
					<a href="#" className="btn btn-white border"><i className="ti ti-loader-3 text-primary me-2"></i>Load More</a>
				</div> */}
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default Client;
